<template>
  <div>
    <div class="appbar-list__global-dropdown__item" @click="openModal">
      <div class="title">Showing artists in</div>
      <div class="value value--country">{{ (selected || {}).name }}</div>
    </div>

    <div class="location-search">
      <modal name="country-modal" height="auto" :adaptive="true"
        @opened="openMultiselect"
      >
        <multiselect
          ref="multiselect"
          :value="selected"
          @select="onSelected"
          placeholder="Search country"
          :options="countries"
          label="name"
          :internalSearch="true"
          track-by="id"
        >
          <span slot="noResult">Nothing was found</span>
        </multiselect>
        <div></div>
      </modal>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  props: {
    selectedCountry: Object
  },
  components: {
    Multiselect
  },
  data: function () {
    return {
      selected: this.selectedCountry,
      countries: []
    }
  },
  mounted() {
    let option = this.selectedCountry
    if (option.name != localStorage.getItem('country_name')) {
      this.$axios({url: `/global_settings/select_country?id=${option.id}`, baseURL: '', method: 'post'})
      .then(response => {
        this.$modal.hide('country-modal')
        localStorage.setItem('location_country', option.slug)
        localStorage.setItem('country_id', option.id)
        localStorage.setItem('country_name', option.name)
      })
    }
  },
  mounted() {
    window.addEventListener('currency-changed', this.updateCurrency)
  },
  beforeDestroy() {
    window.removeEventListener('currency-changed', this.updateCurrency)
  },
  methods: {
    updateCurrency(event) {
      this.onSelected(event.detail.country)
    },
    onSelected (option) {
      this.selected = option
      this.$axios({url: `/global_settings/select_country?id=${option.id}`, baseURL: '', method: 'post'})
        .then(response => {
          this.$modal.hide('country-modal')
          this.$emit('currency', response.data.currency )
          localStorage.setItem('location_currency', response.data.currency.code)
          localStorage.setItem('location_country', option.slug)
          localStorage.setItem('country_id', option.id)
          localStorage.setItem('country_name', option.name)
          localStorage.setItem('short_form', option.short_form)
          localStorage.setItem('show_city', false)
          let excluded_paths = ['messenger', 'gallery', 'profile', 'notifications', 'dashboard', 'user_password', 'blog', 'clients', 'pro', 'terms', 'instant_quote', 'registrations', 'discover', 'services', "policy", "ai", "artist"]
          let path = window.location.pathname.split('/')[1]
          if (!excluded_paths.includes(path)) {
            window.history.replaceState(null, null, option.short_form);
          }
          window.dispatchEvent( new Event('storage') )
          if (!window.location.href.includes("discover")) {
            location.reload()
          } else {
            window.scrollTo({ top: 0, behavior: 'smooth' }) // 👈 Add here!
          }
        })
    },
    openModal () {
      if (this.countries.length > 0) {
        this.$modal.show('country-modal')
      } else {
        this.$axios({url: '/global_settings/countries', baseURL: '', method: 'get'})
          .then(response => {
            this.countries = response.data
            this.$modal.show('country-modal')
          })
      }
    },
    openMultiselect () {
      this.$refs.multiselect.activate();
    },
    closeMultiselect () {
      this.$refs.multiselect.deactivate();
    }
  }
}
</script>
